import { cn } from "@becon-team/becon-fe-lib/my-tailwind-css";
import loadingSpinners from "../../../assets/loadingSpinners.gif";
import { PropsWithChildren } from "react";
import { useLockBodyScroll } from "@becon-team/becon-fe-lib/hooks";

export interface PageSpinLoaderProps {
  backgroundClass?: string;
  spinClass?: string;
  childrenClass?: string;
}

export const Loader = ({ children }: PropsWithChildren<PageSpinLoaderProps>) => {
  useLockBodyScroll(true);

  return (
    <div className={cn("fixed right-0 top-0 z-50 grid h-screen w-screen place-content-center bg-base-0 bg-opacity-60")}>
      <div className="grid place-content-center">
        <img className="w-50ptv" src={loadingSpinners} />
      </div>
      <div className={cn("mt-sp-8")}>{children}</div>
    </div>
  );
};
